import { z } from "zod";
import { PublicIdSchema } from "./common";

/**
 * F14 Slice 2: 配送遅延報告.
 * driver → admin/office_staff へ LINE Push + in_app 通知。
 * F10 申請履歴タブで delivery_status_audit とマージ表示される。
 */

export const DelayReasonSchema = z.enum([
  "traffic",
  "production_delay",
  "previous_case_delay",
  "other",
]);
export type DelayReason = z.infer<typeof DelayReasonSchema>;

export const EtaTypeSchema = z.enum(["unknown", "specified"]);
export type EtaType = z.infer<typeof EtaTypeSchema>;

export const CreateDelayReportInput = z
  .object({
    request_id: PublicIdSchema,
    delay_reason: DelayReasonSchema,
    eta_type: EtaTypeSchema,
    eta_at: z.iso.datetime({ offset: true }).optional(),
    impact_note: z.string().max(1000).optional(),
  })
  .refine((v) => v.eta_type !== "specified" || v.eta_at !== undefined, {
    message: "eta_type=specified の場合 eta_at は必須",
    path: ["eta_at"],
  });
export type CreateDelayReportInputDto = z.infer<typeof CreateDelayReportInput>;

export const StopStatusTarget = z.object({
  stop_id: PublicIdSchema,
  plan_id: PublicIdSchema,
  route_id: PublicIdSchema,
  driver_id: PublicIdSchema,
  delivery_date: z.iso.date(),
});

export const ResolveDelayReportsOutput = z.object({
  stop_id: PublicIdSchema,
  resolved_count: z.number().int().nonnegative(),
  resolved_at: z.iso.datetime({ offset: true }),
});

export const DelayReport = z.object({
  id: PublicIdSchema,
  stop_id: PublicIdSchema,
  delay_reason: DelayReasonSchema,
  eta_type: EtaTypeSchema,
  eta_at: z.iso.datetime({ offset: true }).nullable(),
  impact_note: z.string().nullable(),
  reported_at: z.iso.datetime({ offset: true }),
  reported_by: z.object({
    id: PublicIdSchema,
    name: z.string(),
  }),
  resolved_at: z.iso.datetime({ offset: true }).nullable(),
});
export type DelayReportDto = z.infer<typeof DelayReport>;
